<template>
  <div class="row cust-row">
    <div
      v-for="item in listCustomer"
      :key="item.custCode"
      class="col-md-6 col-xl-4 cust-card"
    >
      <el-card shadow="never">
        <div class="d-flex flex-row">
          <div class="d-flex">
            <!-- <el-avatar shape="square" :src="item.bigImageUrl" /> -->
            <div class="cust-logo-display">
              <el-image
                v-if="item.bigImageCode"
                :src="item.bigImageUrl"
                style="width: 100%; height: 100%"
                fit="contain"
              />
              <span v-else>LOGO</span>
            </div>
          </div>
          <div class="flex-grow-1 pl-3">
            <div class="d-flex justify-content-between" style="width: 100%">
              <div class="cust-abbreviation">
                {{ item.custShortName || item.custName }}
              </div>
              <el-tag
                v-if="item.v_custMode"
                size="small"
                :type="
                  item.custMode === 'A'
                    ? 'info'
                    : item.custMode === 'C'
                    ? 'success'
                    : ''
                "
              >
                {{ item.v_custMode }}
              </el-tag>
            </div>
            <div class="cust-name mt-1" v-if="item.custShortName">
              {{ item.custName }}
            </div>
          </div>
        </div>

        <div class="flex-grow-1"></div>

        <div class="mt-3 customer-tags">
          <el-tag
            class="mr-1"
            size="small"
            :type="
              !item.riskLevel
                ? 'info'
                : item.riskLevel === 'normal'
                ? 'success'
                : item.riskLevel === 'lowRisk'
                ? 'warning'
                : 'danger'
            "
          >
            {{ item.v_riskLevel || $l('form_label_riskLevel_no') }}
          </el-tag>

          <el-tag
            v-if="item.v_customerBizType"
            size="small"
            :type="`customerBizType-${item.customerBizType}`"
            class="mr-1"
          >
            {{ item.v_customerBizType }}
          </el-tag>
          <el-tag
            v-if="item.v_customerType"
            size="small"
            type="info"
            class="mr-1"
          >
            {{ item.v_customerType }}
          </el-tag>
          <el-tag v-if="item.regionName" size="small" type="info" class="mr-1">
            {{ item.regionName }}
          </el-tag>
        </div>

        <el-row :gutter="10" class="mt-2">
          <el-col :span="12">
            <div class="cust-budgetary-item">
              <div>{{ item.budgetYear }}</div>
              <div>{{ $l('form_label_budgetYear') || '预算年度' }}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="cust-budgetary-item">
              <div class="text-truncate">{{ item.budgetAmount }}</div>
              <div>{{ $l('form_label_budgetAmount') || '预算金额' }}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="cust-budgetary-progress mt-2">
          <el-col :span="24">
            <div class="d-flex justify-content-between mb-1">
              <span>{{ $l('form_label_budgetProgress') || '预算完成率' }}</span>
              <span class="cust-budgetary-percentage">
                {{ `${item.budgetProgress || 0}%` }}
              </span>
            </div>
            <b-progress
              variant="success"
              height="0.4rem"
              style="width: 100%"
              :value="item.budgetProgress || 0"
              :max="100"
            />
          </el-col>
        </el-row>

        <div class="d-flex justify-content-between align-items-end mt-3">
          <div style="min-width: 150px">
            <b-avatar-group size="2.6rem" overlap="0.5">
              <b-avatar
                v-for="user in item.listTeamUser"
                :key="user.userCode"
                :src="user.memImgUrl"
                :title="user.userName"
                v-b-tooltip.hover
              />
              <el-badge
                v-if="item.teamUserCount && item.teamUserCount > 5"
                :value="item.teamUserCount"
              />
            </b-avatar-group>
          </div>
          <div class="d-flex justify-content-end">
            <ActionButton :item="item" @reload="$emit('reload')" />
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { format } from '@/libs/util.number.js'
import ActionButton from './action-button'
export default {
  components: { ActionButton },
  props: { data: { type: Array, default: () => [] } },
  computed: {
    listCustomer() {
      if (!this.data?.length) return []
      return this.data.map((item) => {
        const budgetAmount = format(item.budgetAmount)
        return {
          ...item,
          budgetAmount: budgetAmount ? `$${budgetAmount}` : '--',
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  // .el-avatar {
  //   --size: 60px;
  //   width: var(--size);
  //   height: var(--size);
  // }
  .el-card {
    height: 100%;
  }
  .el-card__body {
    height: 100%;
    padding: 14px;
    display: flex;
    flex-direction: column;
  }
  .el-tag--customerBizType-foreignTrade {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
  .el-tag--customerBizType-domesticTrade {
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
  }
}
.cust-logo-display {
  width: 60px;
  height: 60px;
  min-width: 60px;
  background-color: #f4f6f9;
  font-size: 14px;
  color: #101010;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cust-row.row {
  margin-right: -5px;
  margin-left: -5px;
  margin-top: 10px;
  .cust-card {
    margin-top: 10px;
    padding-right: 5px;
    padding-left: 5px;
  }
  .cust-card:nth-child(-n + 3) {
    margin-top: 0;
  }
}

.cust-abbreviation {
  font-size: 16px;
  color: #101010;
  padding-right: 5px;
}
.cust-name {
  font-size: 14px;
  color: #8e8e8e;
}

.customer-tags {
  .el-tag {
    width: 70px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.cust-budgetary-item {
  border: 1px dashed #e1e3ea;
  border-radius: 5px;
  padding: 10px;
  :nth-child(1) {
    font-weight: 500;
    font-size: 18px;
    color: #101010;
  }
  :nth-child(2) {
    font-size: 14px;
    color: #8e8e8e;
  }
}

.cust-budgetary-progress {
  font-size: 14px;
  color: #8e8e8e;
  .cust-budgetary-percentage {
    font-size: 16px;
    color: #101010;
  }
}
</style>
